export default "__VITE_ASSET__C5ASeU1A__"